import Wrapper from './components/Wrapper'
import DropZone from './components/DropZone'
import FileList from './components/FileList'

const DragDropFile = (): null => null

DragDropFile.Wrapper = Wrapper
DragDropFile.DropZone = DropZone
DragDropFile.FileList = FileList

export default DragDropFile
